import { Chip } from '@prenuvo/halo-web';
import { isResearchOnlyLocation } from '@/utils/replaceLocationBasedTerms';
import { skuData } from './data';
import { useSkuDetails } from '@/hooks';

import {
  SKU_370_ENABLED_LOCATIONS,
  SKU_300_ALTERNATE_SUBTITLE,
  SKU_300_ALTERNATE_DESCRIPTION,
  SKU_370_INFO_HYPERLINK,
  ISAUSTRALIANLOCATION,
} from '@/constants';
import { calculateDiscount } from '@/utils/payment/discount';

export default function SkuDetails() {
  const { discount, discountType, locationId, marketingReferral, selectedSku, referralCredit } =
    useSkuDetails();

  if (!selectedSku) return null;

  const selectedSkuData = skuData.find((sku) => sku.sku === selectedSku.skuID);

  const isSku370EnabledAtLocation = SKU_370_ENABLED_LOCATIONS.map(
    (location) => location.locationId,
  ).includes(locationId);

  const displayAlternativeSku300Details =
    isSku370EnabledAtLocation || ISAUSTRALIANLOCATION(locationId);
  // Use the modified subtitle for SKU 300 IF its selected AND SKU 370 is also enabled at location
  const subtitle =
    displayAlternativeSku300Details && selectedSku.skuID === '300'
      ? SKU_300_ALTERNATE_SUBTITLE
      : selectedSkuData?.subtitle;

  // Use the modified description for SKU 300 if its selected AND SKU 370 is also enabled at location
  const description =
    displayAlternativeSku300Details && selectedSku.skuID === '300'
      ? SKU_300_ALTERNATE_DESCRIPTION
      : selectedSkuData?.description;

  const { finalPrice, totalDiscount } = calculateDiscount({
    sku: selectedSku,
    discount,
    discountType,
    marketingReferral,
    referralCredit,
    locationId,
  });

  return (
    <div className="gradient-section-bg">
      <div className="gradient-section">
        <div className="p-5 md:p-6">
          <div className="mb-4">
            <h3 className="mb-2 font-lato text-xl font-semibold">{selectedSku?.shortName}</h3>
            {!isResearchOnlyLocation(locationId) && (
              <p className="mb-6 text-sm text-grayed">{subtitle}</p>
            )}
            {!isResearchOnlyLocation(locationId) && (
              <div>
                <p className="font-normal">{description}</p>
              </div>
            )}
            {selectedSku.skuID === '370' && (
              <div className="mt-4">
                <p className="text-sm">
                  See more information about{' '}
                  <a
                    href={SKU_370_INFO_HYPERLINK}
                    className="text-green-700"
                    target="_blank"
                    rel="noreferrer"
                  >
                    Enhanced Screening
                  </a>
                  {'.'}
                </p>
              </div>
            )}
          </div>
          <div className="flex items-end justify-between">
            <div>
              <p className="md:text-md text-sm text-grayed">Scan Price:</p>
              {totalDiscount && finalPrice >= 0 ? (
                <div className="flex flex-row items-end gap-4">
                  <p className="text-xl font-semibold">
                    {selectedSku.price.currency} {finalPrice.toFixed(2)}
                  </p>
                  <p className="text-sm text-neutral-700 line-through">
                    {selectedSku.price.currency} {selectedSku.price.total}
                  </p>
                </div>
              ) : (
                <p className="text-xl font-semibold">
                  {selectedSku.price.currency} {selectedSku.price.total}
                </p>
              )}
            </div>
            <div>
              <Chip className="pointer-events-none border-none bg-neutral-100 px-3 py-[6px]">
                {selectedSku.marketedTime} minutes
              </Chip>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
